import HeroDescription from '../../Headings/HeroDescription'
import HeroHeading from '../../Headings/HeroHeading'
import FirstBadge from '../../../Icons/coaching/funnel/bages/1.svg'
import SecondBadge from '../../../Icons/coaching/funnel/bages/2.svg'
import ThirdBadge from '../../../Icons/coaching/funnel/bages/3.svg'
import FourthBadge from '../../../Icons/coaching/funnel/bages/4.svg'
import RightIcon from '../../../Icons/coaching/funnel/right-icon.svg'
import BookACallFunnelButton from '../../Buttons/Specials/BookACallFunnelButton'

export default function HeroBanner() {
    return (
        <div className="max-w-7xl mx-auto px-2 space-y-10">
            <div className="justify-center space-y-2 text-center max-w-full md:max-w-3xl m-auto">
                <HeroHeading>
                    Book a <span className="olm-gradient-text">FREE</span>{' '}
                    Coaching <br className="block md:hidden" /> Call:{' '}
                    <br className="hidden md:block" />
                    Unlock Your Direct <br className="block md:hidden" /> Mail
                    Success
                </HeroHeading>
                <div className="justify-center text-center max-w-md md:max-w-2xl m-auto">
                    <HeroDescription>
                        <p className="">
                            Unlock the full potential of your direct mail
                            campaigns with our personalized coaching sessions.
                            Our experts are here to guide you through every step
                            of the process, ensuring you achieve the best
                            possible results.
                        </p>
                    </HeroDescription>
                </div>
            </div>

            <div className="md:w-2/4 block md:hidden text-center md:text-left md:space-y-6 space-y-10">
                <div className="bg-white space-y-6">
                    <h2 className="text-xl md:text-2xl font-bold mb-4">
                        Book a coaching call now and take advantage of our
                        special offer:
                    </h2>
                    <div className="w-10/12 md:w-full m-auto">
                        <ul className="text-left space-y-4">
                            <li className="flex items-center">
                                <span className="text-orange-500 mr-4">
                                    <RightIcon />
                                </span>
                                <span>Free Coaching Call (Worth $250)</span>
                            </li>
                            <li className="flex items-center">
                                <span className="text-orange-500 mr-4">
                                    <RightIcon />
                                </span>
                                <span>1500 Free Leads (Worth $400)</span>
                            </li>
                            <li className="flex items-center">
                                <span className="text-orange-500 mr-4">
                                    <RightIcon />
                                </span>
                                <span>10% OFF</span>
                            </li>
                            <li className="flex items-center">
                                <span className="text-orange-500 mr-4">
                                    <RightIcon />
                                </span>
                                <span>Free Resources (Worth $500)</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="space-y-2 w-11/12 m-auto">
                    <BookACallFunnelButton>
                        Book Your FREE Coaching Call
                    </BookACallFunnelButton>
                    <p className="olm-gradient-text italic font-semibold text-center">
                        Limited Time Offer
                    </p>
                </div>
            </div>

            <div className="flex max-w-5xl m-auto flex-col md:flex-row items-center space-y-5 md:space-y-0 md:space-x-8">
                <div className="md:w-2/4 md:block space-y-5 max-w-full">
                    <img
                        src="/assets/coaching/hero.png"
                        alt="Three diverse, smiling coaches are displayed in circular profile pictures against a gray background with concentric orange circles."
                        title="Customer support team with contact icons."
                        width={430}
                        height={308}
                        className="h-auto max-w-full"
                    />
                    <div className="flex space-x-4 justify-between">
                        <FirstBadge />
                        <ThirdBadge />
                        <SecondBadge />
                        <FourthBadge />
                    </div>
                </div>

                <div className="md:w-2/4 hidden md:block text-center md:text-left md:space-y-6 space-y-2 px-1">
                    <div className="bg-white space-y-6">
                        <h2 className="text-2xl font-bold mb-4">
                            Book a coaching call now and take advantage of our
                            special offer:
                        </h2>
                        <div className="w-9/12 md:w-full m-auto">
                            <ul className="text-left space-y-4">
                                <li className="flex items-center">
                                    <span className="text-orange-500 mr-4">
                                        <RightIcon />
                                    </span>
                                    <span>Free Coaching Call (Worth $250)</span>
                                </li>
                                <li className="flex items-center">
                                    <span className="text-orange-500 mr-4">
                                        <RightIcon />
                                    </span>
                                    <span>1500 Free Leads (Worth $400)</span>
                                </li>
                                <li className="flex items-center">
                                    <span className="text-orange-500 mr-4">
                                        <RightIcon />
                                    </span>
                                    <span>10% OFF</span>
                                </li>
                                <li className="flex items-center">
                                    <span className="text-orange-500 mr-4">
                                        <RightIcon />
                                    </span>
                                    <span>Free Resources (Worth $500)</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="hidden md:block w-96 space-y-2">
                        <BookACallFunnelButton>
                            Book Your FREE Coaching Call
                        </BookACallFunnelButton>
                        <p className="olm-gradient-text italic font-semibold text-center">
                            Limited Time Offer
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
